export enum MetricMultiplierType {
	NONE = 'none',
	DIVIDE_HUNDRED = 'divide_100',
	TIMES_HUNDRED = 'times_100',
}
